import _ from "lodash";
import config from "../config";
import JSZip from "jszip";

const dayjs = require("dayjs");

const getToday = () => {
  return dayjs().format("YYYY-MM-DD HH:mm:ss");
  // return dayjs().toISOString();
};

const getTomorrow = () => {
  return dayjs().add(1, "day").format("YYYY-MM-DD HH:mm:ss");
};

const getYesterday = () => {
  return dayjs().subtract(1, "day").format("YYYY-MM-DD HH:mm:ss");
  // return dayjs().subtract(1, "day").toISOString();
};

const getBeforeSevenDay = () => {
  return dayjs().subtract(7, "day").format("YYYY-MM-DD HH:mm:ss");
};

const getLastMonth = () => {
  return dayjs().subtract(1, "month").format("YYYY-MM-DD HH:mm:ss");
};

const compareFn = (a, b) => {
  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
};

const parseFullNameFromUser = (user) => {
  if (!user) return "-";
  const name = user.name || "";
  const lastname = user.lastname || "";
  const fullName = `${name} ${lastname}`.trim();
  return fullName || "-";
};

const parseStatus = (status) => {
  let statusText;
  if (status === "1") {
    statusText = (
      <div
        className={`rounded-lg max-w-max border border-blue-500 px-2 py-1 text-xs text-blue-500`}
      >
        รอการดำเนินการตรวจสอบ
      </div>
    );
  } else if (status === "2") {
    statusText = (
      <span
        className={`rounded-lg w-max border border-green-500 px-2 py-1 text-xs text-green-500`}
      >
        ผ่านการตรวจสอบ
      </span>
    );
  } else if (status === "3") {
    statusText = (
      <span
        className={`rounded-lg w-max border border-red-500 px-2 py-1 text-xs text-red-500`}
      >
        ไม่ผ่านการตรวจสอบ
      </span>
    );
  } else if (status === "4") {
    statusText = (
      <span
        className={`rounded-lg w-max bg-green-600 px-2 py-1 text-xs text-white`}
      >
        ผ่านการอนุมัติ
      </span>
    );
  } else if (status === "5") {
    statusText = (
      <span
        className={`rounded-lg w-max bg-red-500 px-2 py-1 text-xs text-white`}
      >
        ไม่ผ่านการอนุมัติ
      </span>
    );
  }
  //  else if (status === "6") {
  //   statusText = (
  //     <span
  //       className={`rounded-lg max-w-max border border-orange-500 px-2 py-1 text-xs text-orange-500`}
  //     >
  //       รอการแก้ไข
  //     </span>
  //   );
  // } else if (status === "7") {
  //   statusText = (
  //     <span
  //       className={`rounded-lg max-w-max border border-blue-500 px-2 py-1 text-xs text-blue-500`}
  //     >
  //       แก้ไขสำเร็จ
  //     </span>
  //   );
  // }
  else {
    statusText = "Invalid status";
  }
  return statusText;
};

const parseStatusRevise = (status) => {
  let statusText;
  if (status === "1") {
    statusText = (
      <div
        className={`rounded-lg max-w-max border border-blue-500 px-2 py-1 text-xs text-blue-500`}
      >
        รอการดำเนินการตรวจสอบ
      </div>
    );
  } else if (status === "2") {
    statusText = (
      <span
        className={`rounded-lg w-max bg-green-600 px-2 py-1 text-xs text-white`}
      >
        ผ่านการตรวจสอบจาก Checker
      </span>
    );
  } else if (status === "3") {
    statusText = (
      <span
        className={`rounded-lg w-max bg-red-500 px-2 py-1 text-xs text-white`}
      >
        ไม่ผ่านการตรวจสอบจาก
      </span>
    );
  } else if (status === "4") {
    statusText = (
      <span
        className={`rounded-lg w-max bg-green-600 px-2 py-1 text-xs text-white`}
      >
        ผ่านการตรวจสอบจาก
      </span>
    );
  } else if (status === "5") {
    statusText = (
      <span
        className={`rounded-lg w-max bg-red-500 px-2 py-1 text-xs text-white`}
      >
        ไม่ผ่านการตรวจสอบจาก
      </span>
    );
  } else {
    statusText = "Invalid status";
  }
  return statusText;
};

const statusRevise = (status) => {
  let statusText;
  if (status === "0") {
    statusText = "";
  } else if (status === "1") {
    statusText = (
      <span
        className={`ml-2 rounded-lg max-w-max border border-green-600 px-2 py-1 text-xs text-green-600`}
      >
        เพิ่ม
      </span>
    );
  } else if (status === "2") {
    statusText = (
      <span
        className={`ml-2 rounded-lg max-w-max border border-yellow-500 px-2 py-1 text-xs text-yellow-500`}
      >
        แก้ไข
      </span>
    );
  } else if (status === "3") {
    statusText = (
      <span
        className={`ml-2 rounded-lg max-w-max border border-red-500 px-2 py-1 text-xs text-red-500`}
      >
        ลบ
      </span>
    );
  } else {
    statusText = "";
  }
  return statusText;
};

const sortData = (data, field) => {
  return data;
};

const statusPartSuccess = (status) => {
  let statusText;
  if (status === true) {
    statusText = (
      <div
        className={`rounded-lg max-w-max border border-blue-500 px-2 py-1 text-xs text-blue-500`}
      >
        เพิ่มข้อูล part สำเร็จ
      </div>
    );
  } else if (status === false) {
    statusText = (
      <span
        className={`rounded-lg w-max border border-green-500 px-2 py-1 text-xs text-green-500`}
      >
        เพิ่มข้อูล part ไม่สำเร็จ
      </span>
    );
  } else {
    statusText = "Invalid status";
  }
  return statusText;
};

const scrollToRef = (ref) => {
  if (ref) {
    setTimeout(() => {
      ref.scrollIntoView({ behavior: "auto" });
    }, 100);
  }
};

const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

const sortSignature = (signature) => {
  return signature.sort((a, b) =>
    dayjs(a.createdAt).isAfter(dayjs(b.createdAt), "minute")
      ? -1
      : dayjs(a.createdAt).isBefore(dayjs(b.createdAt), "minute")
      ? 1
      : 0
  );
};

const exportData = (paper) => {
  let dataExport;
  if (paper) {
    const shift = paper.shiftAB ? paper.shiftAB : paper.shift;
    const partData = paper.partName;
    const process_status = paper.process_status ? paper.process_status : "-";
    const partName = partData.part_name;
    const partCode = partData.part_code;
    // const imageData = partData.attributes?
    const imagePart = partData.image.url || null;

    const reviseData = [];
    const dataOldPart = partData.revise;
    const sliceDate = dataOldPart.createdAt.slice(0, 10);
    const splitDate = sliceDate.split("-").reverse();
    const revise_date = splitDate[0] + "-" + splitDate[1] + "-" + splitDate[2];
    const reviseFromRealPart = {
      id: partData.id,
      date: revise_date,
      revise_time: partData.revise_time,
      revisionRecord: partData.revise.revisionRecord,
      releaseForRevise: partData.revise.release_id.name,
      checkerForRevise: partData.revise.checker_id.name,
      approverForRevise: partData.revise.approver_id.name,
    };
    const old_parts = partData.old_parts;
    if (old_parts.length > 0) {
      const dataOldPart = partData.old_parts;
      dataOldPart.forEach((loopOldPart) => {
        const dataRevise = loopOldPart.revise;
        const sliceDate = dataRevise.createdAt.slice(0, 10);
        const splitDate = sliceDate.split("-").reverse();
        const date = splitDate[0] + "-" + splitDate[1] + "-" + splitDate[2];
        reviseData.push({
          id: loopOldPart.id,
          date: date,
          revise_time: loopOldPart.attributes
            ? loopOldPart.attributes.revise_time
            : loopOldPart.revise_time,
          revisionRecord: dataRevise.revisionRecord,
          releaseForRevise: dataRevise.release_id.name,
          checkerForRevise: dataRevise.checker_id.name,
          approverForRevise: dataRevise.approver_id.name,
        });
      });
      reviseData.push(reviseFromRealPart);
    } else {
      reviseData.push(reviseFromRealPart);
    }
    let dataQuestion = [];
    console.log("partData 94:", partData);
    paper.answer.sub_categories.forEach((subCat) => {
      subCat.questions.forEach((question) => {
        dataQuestion.push({
          spec_min: question.spec_min,
          spec_max: question.spec_max,
          checkPoint: question.questionName,
          answer1: question.answer[0],
          answer2: question.answer[1],
          answer3: question.answer[2],
          actual1: question.actual[0],
          actual2: question.actual[1],
          actual3: question.actual[2],
          comment1: question.comment[0],
          comment2: question.comment[1],
          comment3: question.comment[2],
          typeCheck: subCat.category,
          revise_time: question.revise_time,
          lastRevise: partData.revise_time === question.revise_time,
          sub_category: subCat.sub_category,
        });
      });
    });

    dataExport = {
      dataquestion: dataQuestion,
      date: paper.date,
      time: paper.time,
      shift: shift,
      process_status: process_status,
      partName: partName,
      partCode: partCode,
      imagePart: imagePart,
      reviseData: reviseData,
      signature_approver: paper.signature_approver && paper.signature_approver,

      signature_checker: paper.signature_checker && paper.signature_checker,

      signature_inspector:
        paper.signature_inspector && paper.signature_inspector,
    };
  }
  return dataExport;
};

//////////////////////////////EXportDataCPl

// const exportDataCPL = (paper) => {
//   let dataExport;
//   if (paper) {
//     const data = paper[0];
//     const partData = paper[0].partName;
//     const partName = partData.part_name;
//     const imagePart = paper[0].partName.image.url;
//     let dataQuestion = [];
//     console.log("Part Data :", data);
//     data.answer.sub_categories.forEach((subCat) => {
//       subCat.questions.forEach((question) => {
//         dataQuestion.push({
//           spec_min: question.spec_min,
//           spec_max: question.spec_max,
//           checkPoint: question.questionName,
//           answer1: question.answer[0],
//           answer2: question.answer[1],
//           answer3: question.answer[2],
//           actual1: question.actual[0],
//           actual2: question.actual[1],
//           actual3: question.actual[2],
//           comment1: question.comment[0],
//           comment2: question.comment[1],
//           comment3: question.comment[2],
//           typeCheck: subCat.category,
//           revise_time: question.revise_time,
//           lastRevise: partData.revise_time === question.revise_time,
//           sub_category: subCat.sub_category,
//         });
//       });
//     });

//     console.log(dataQuestion);

//     dataExport = {
//       dataquestion: dataQuestion,
//       date: paper.date,
//       time: paper.time,
//       partName: partName,
//       imagePart: imagePart,
//       signature_approver: paper.signature_approver && paper.signature_approver,
//       signature_checker: paper.signature_checker && paper.signature_checker,
//       signature_inspector:
//         paper.signature_inspector && paper.signature_inspector,
//     };
//   }
//   return exportDataCPL;
// };

////////////////////////////EXportDataCPl
const exportDataALL = (paper) => {
  let dataExportALL;

  if (!paper || !paper.length) {
    console.error("No paper data available.");
    return null;
  }
  const data = paper[0];
  const partData = data.partName;
  const partName = partData?.part_name;
  const imagePart = partData?.image?.[0]?.url;

  if (!partData) {
    console.error("Part data is missing or incomplete.");
    return null; // Exit if critical part data is missing
  }

  let dataQuestion = [];
  console.log("Part Data:", data);

  data.answer.sub_categories.forEach((subCat) => {
    subCat.questions.forEach((question) => {
      dataQuestion.push({
        spec_min: question.spec_min,
        spec_max: question.spec_max,
        checkPoint: question.questionName,
        answer1: question.answer.filter((e) => e !== ""),
        answer2: question.answer.filter((e) => e !== ""),
        answer3: question.answer.filter((e) => e !== ""),
        actual1: question.actual.filter((e) => e !== ""),
        actual2: question.actual.filter((e) => e !== ""),
        actual3: question.actual.filter((e) => e !== ""),
        comment1: question.comment.filter((e) => e !== ""),
        comment2: question.comment.filter((e) => e !== ""),
        comment3: question.comment.filter((e) => e !== ""),
        // inspectionTool: data.inspectionTool || "",
        typeCheck: subCat.category,
        revise_time: question.revise_time,
        lastRevise: partData.revise_time === question.revise_time,
        sub_category: subCat.sub_category,
      });
    });
  });

  console.log(dataQuestion);

  dataExportALL = {
    dataquestion: dataQuestion,
    date: data.date,
    time: data.time,
    partName: partName,
    imagePart: imagePart,
    signature_approver: data.signature_approver,
    signature_checker: data.signature_checker,
    signature_inspector: data.signature_inspector,
  };

  return dataExportALL;
};

const getImageUrl = (url) => {
  if (typeof url !== "string" || !url) return "";
  if (url.startsWith("http")) return url;
  return `${config.server}${url}`;
};

const injectImageIfPlaceholderExists = async (arrayBuffer, imgArrayBuffer) => {
  try {
    const zip = new JSZip();
    await zip.loadAsync(arrayBuffer);

    // 1. Write the new image file
    zip.file("xl/media/image_part.png", imgArrayBuffer);

    // 2. Add a relationship entry in drawing1.xml.rels
    const relsPath = "xl/drawings/_rels/drawing1.xml.rels";
    const relsFile = zip.file(relsPath);
    if (relsFile) {
      let relsXml = await relsFile.async("text");
      const newRelId = "rId99";
      const newRel = `<Relationship Id="${newRelId}" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/image" Target="../media/image_part.png"/>`;
      relsXml = relsXml.replace("</Relationships>", newRel + "</Relationships>");
      zip.file(relsPath, relsXml);

      // 3. Add a twoCellAnchor in drawing1.xml for A4:K10
      const drawingPath = "xl/drawings/drawing1.xml";
      const drawingFile = zip.file(drawingPath);
      if (drawingFile) {
        let drawingXml = await drawingFile.async("text");
        const anchor = `<xdr:twoCellAnchor editAs="oneCell"><xdr:from><xdr:col>0</xdr:col><xdr:colOff>0</xdr:colOff><xdr:row>3</xdr:row><xdr:rowOff>0</xdr:rowOff></xdr:from><xdr:to><xdr:col>11</xdr:col><xdr:colOff>0</xdr:colOff><xdr:row>10</xdr:row><xdr:rowOff>0</xdr:rowOff></xdr:to><xdr:pic><xdr:nvPicPr><xdr:cNvPr id="999" name="PartImage"/><xdr:cNvPicPr><a:picLocks noChangeAspect="1"/></xdr:cNvPicPr></xdr:nvPicPr><xdr:blipFill><a:blip xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" r:embed="${newRelId}"/><a:stretch><a:fillRect/></a:stretch></xdr:blipFill><xdr:spPr><a:xfrm><a:off x="0" y="0"/><a:ext cx="0" cy="0"/></a:xfrm><a:prstGeom prst="rect"><a:avLst/></a:prstGeom></xdr:spPr></xdr:pic><xdr:clientData/></xdr:twoCellAnchor>`;
        drawingXml = drawingXml.replace("</xdr:wsDr>", anchor + "</xdr:wsDr>");
        zip.file(drawingPath, drawingXml);
      }
    }

    // 4. Ensure Content_Types has png
    const ctPath = "[Content_Types].xml";
    const ctFile = zip.file(ctPath);
    if (ctFile) {
      let ctXml = await ctFile.async("text");
      if (!ctXml.includes('Extension="png"')) {
        ctXml = ctXml.replace("<Types", '<Types><Default Extension="png" ContentType="image/png"/>');
      }
      zip.file(ctPath, ctXml);
    }

    return await zip.generateAsync({ type: "arraybuffer" });
  } catch (err) {
    console.error("Failed to inject image into template via JSZip", err);
  }
  return arrayBuffer;
};

export {
  getToday,
  getTomorrow,
  getYesterday,
  parseFullNameFromUser,
  parseStatus,
  getBeforeSevenDay,
  getLastMonth,
  parseStatusRevise,
  statusRevise,
  sortData,
  statusPartSuccess,
  scrollToRef,
  getBase64,
  sortSignature,
  exportData,
  exportDataALL,
  getImageUrl,
  injectImageIfPlaceholderExists
};
